module.exports = __webpack_public_path__ + "static/media/title.d97b1d98.png";